import * as React from "react";

function SvgSmoothDemand(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 7l2 3 2-3 2 3 2-3 2 3 2-3 2 3" stroke="#FF825C" /></svg>;
}

export default SvgSmoothDemand;